<template>
    <button class="c-button c-button--icons" :class="{'c-button--active': selected}" :disabled="disabled" @click="toggle">
        <img class="c-button__icon" v-if="icon" :src="icon" />
        <span class="c-button__icon" v-if="!icon">Aa</span>
        {{ text }}
    </button>
</template>

<script>
    export default {
        props: {
            icon: { type: String },
            text: { type: String },
            disabled: { type: Boolean },
            selected: { type: Boolean }
        },
        methods: {
            toggle: function () {
                this.selected = !this.selected;
                this.$emit("select", this.selected);
            }
        },
    };
</script>